export const STANDBY_POWER_THRESHOLD_W = 50;

export type EnergyInsightMetrics = {
	selfPoweredPct: number;
	gridExposurePct: number;
	standbyPct: number;
};

export const calculateEnergyInsightMetrics = ({
	loadW,
	solarW,
	gridW,
	standbyW,
}: {
	loadW: number;
	solarW: number;
	gridW: number;
	standbyW: number;
}): EnergyInsightMetrics => {
	const demand = Math.max(loadW, 0);
	const solarSupply = Math.max(solarW, 0);
	const gridSupply = Math.max(gridW, 0);
	const totalSupply = solarSupply + gridSupply;
	const selfPoweredPct =
		totalSupply > 0 ? Math.min(Math.round((solarSupply / totalSupply) * 100), 100) : 0;

	return {
		selfPoweredPct,
		gridExposurePct: totalSupply > 0 ? 100 - selfPoweredPct : 0,
		standbyPct: demand > 0 ? Math.min(Math.round((Math.max(standbyW, 0) / demand) * 100), 100) : 0,
	};
};
